const Styles = {
    'Button': 'Button_Button--31545f9f',
    'minimal': 'Button_minimal--21445cd1',
    'label': 'Button_label--8d8664a4'
};

export default Styles;